<template>
  <div class="container mx-auto px-4 bg-yellow min-h-screen">
    <div class="px-4 pt-20 pb-20">
      <Sidebar></Sidebar>
      <Header>{{$t('all.family')}}</Header>
      <Familiare
        v-for="familiare in familiari"
        :id="id"
        :familiare="familiare"
        :key="familiare.id"
      ></Familiare>
      <router-link
        :to="{name: 'GenitoriAdd', params: {id: id}}"
        class="no-underline"
      >
        <div class="rounded-full mt-5 p-4 py-2 bg-pink-dark text-white text-center"><i class="fas fa-plus"></i></div>
      </router-link>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: ['id'],
  created() {
    this.getFamiliariMinore(this);
  },
  computed: {
    ...mapGetters({
      familiari: 'familiari/familiari',
    }),
  },
  methods: {
    ...mapActions('familiari', ['getFamiliariMinore']),
  },
};
</script>
